import useSWR from 'swr'
import axios from 'axios'
const fetcher = async url => {
    const res = await axios(url)
    if (Array.isArray(res.data)) {
        return [...res.data]
    }
    return res.data
}

export const useImages = ()=> {
    const { data } = useSWR(process.env.REACT_APP_BACKEND+'/image-gallery', fetcher)

    return {
        data
    }
}